define('fukit/behavior/change.visibility.on.state.editing.behavior',['require','marionette','backbone.radio'],function(require) {
  //prettier-ignore
  var Mn    = require('marionette'),
      Radio = require('backbone.radio');

  var ChangeVisiblityOnStateEditingBehavior = Mn.Behavior.extend({
    defaults: {
      visibleWhenEditing: false,
    },

    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);

      this.once('before:render', function() {
        this.updateViewVisibility();
        this.initializeStateChangeEvents();
      });
    },

    initializeStateChangeEvents: function() {
      this.listenTo(this.getState(), 'change:editing', function() {
        this.updateViewVisibility();
      });
    },

    getState: function() {
      return Radio.channel('AppKit.controllerService').request('state');
    },

    updateViewVisibility: function() {
      this.view.visible = this.shouldViewBeVisible();
    },

    shouldViewBeVisible: function() {
      //prettier-ignore
      var isEditing = !!this.getState().get('editing'),
          visibleWhenEditing = Mn._getValue(this.getOption('visibleWhenEditing'), this);

      if (visibleWhenEditing) {
        return isEditing;
      } else {
        return !isEditing;
      }
    },
  });

  return ChangeVisiblityOnStateEditingBehavior;
});

